import React, { useEffect, useRef, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { BsCheck } from "react-icons/bs";
import { CiEdit, CiPen } from "react-icons/ci";
import { axios } from "../../../../Global";
import RowExistingPopup from "./RowExistingPopup";
import { MdDelete } from "react-icons/md";
import DeletePrompt from "./DeletePrompt";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";

export default function InsuranceCompany() {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const insuranceComponentDiv = useRef(null);
  const [isExistingPopupOpen, setIsExistingPopupOpen] = useState({
    open: false,
    id: "",
    submitted: true,
  });
  const [showDeletePrompt, setShowDeletePrompt] = useState({
    open: false,
    rowId: "",
    schemaId: "",
    deleteHandler: null,
  });

  const [allTitles, setAllTitles] = useState([]);
  const [allRowsInitial, setAllRowsInitial] = useState([]);
  const [allRows, setAllRows] = useState([]);

  // const [initialDataSaved,setInitialDataSaved] = useState(false)

  const [updateData, setUpdateData] = useState(false);

  useEffect(() => {
    if (isExistingPopupOpen.submitted) {
      console.log("useEffect running");
      axios
        .get("/dashboard/insurance", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const defaultRows = response.data.data;
          const rows = defaultRows.map((row) => {
            return {
              insurance_id: row.id,
              name: row.name,
              editing: false,
              schemas: row.insurance_scheme,
            };
          });
          console.log("response to be printed in console",rows)
          setAllRows(rows);
          // if(!initialDataSaved){
          setAllRowsInitial(rows);

          // }
        })
        .catch((err) => {
          dispatch(setAppError({ msg: "Fetching data failed." }));
        });
    }
  }, [isExistingPopupOpen, updateData]);

  useEffect(() => {
    if (allRows?.length >= 1) {
      const objectsWithLargestSchema = allRows?.filter(
        (obj) =>
          obj?.schemas?.length ===
          allRows.reduce((max, obj) => Math.max(max, obj?.schemas?.length), 0)
      );

      objectsWithLargestSchema.sort((a, b) => a?.id - b?.id);
      if (objectsWithLargestSchema) {
        const maxSchema = objectsWithLargestSchema[0]?.schemas;
        const updatedAllTitles = [];
        for (let i = 0; i < maxSchema?.length; i++) {
          updatedAllTitles.push({
            id: Math.floor(Math.random() * 10000),
            mainTitle: "Scheme",
            employee: "Employee",
            spouse: "Spouse",
            child: "Child",
          });
        }
        setAllTitles(updatedAllTitles);
      }
    }
  }, [allRows]);

  const handleCreateRow = () => {
    const newInsuranceId = Math.floor(Math.random() * 10000);
    setAllRows((prevState) => [
      ...prevState,
      {
        insurance_id: newInsuranceId,
        name: "",
        policy_no: "",
        policy_effective_date: "",
        policy_end_date: "",
        editing: true,
        schemas: [
          {
            id: 1,
            insurance_id: newInsuranceId,
            scheme_name: "VIP",
            employee: "",
            spouse: "",
            child: "",
          },
          {
            id: 2,
            insurance_id: newInsuranceId,
            scheme_name: "A",
            employee: "",
            spouse: "",
            child: "",
          },
          {
            id: 3,
            insurance_id: newInsuranceId,
            scheme_name: "B",
            employee: "",
            spouse: "",
            child: "",
          },
          {
            id: 4,
            insurance_id: newInsuranceId,
            scheme_name: "C",
            employee: "",
            spouse: "",
            child: "",
          },
        ],
      },
    ]);
    insuranceComponentDiv.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  const handleEnableRowEdit = (rowId) => {
    const updatedRows = allRows.map((row) => {
      if (row.insurance_id == rowId) {
        return { ...row, editing: true };
      }
      return row;
    });
    setAllRows(updatedRows);
  };

  const handleUpdateColumn = (rowId, schemaId, updatingKey, updatingValue) => {
    const updatedRows = allRows.map((row) => {
      if (row.insurance_id == rowId) {
        const updatedSchemas = row.schemas.map((schema) => {
          if (schema.id == schemaId) {
            return { ...schema, [updatingKey]: updatingValue };
          }
          return schema;
        });
        return { ...row, schemas: updatedSchemas };
      }
      return row;
    });
    setAllRows(updatedRows);
  };

  const handleUpdateRowName = (rowId, updatingValue) => {
    console.log("ygryegrgggrugu", rowId, updatingValue);
    const updatedRows = allRows.map((row) => {
      if (row.insurance_id == rowId) {
        return { ...row, name: updatingValue };
      }
      return row;
    });
    console.log("updatedRows.......", updatedRows);
    setAllRows(updatedRows);
  };

  const handlepolicyrowUpdate = (id, updatedValue, Check) => {
    console.log("allRows before update:", allRows);
    const updatedRows = allRows.map((insurance) => {
      return {
        ...insurance,
        schemas: insurance.schemas.map((schema) => {
          if (insurance.insurance_id === id && Check === "policy_no") {
            return {
              ...schema,
              policy_no: updatedValue,
            };
          } else if (
            insurance.insurance_id === id &&
            Check === "effective_date"
          ) {
            return {
              ...schema,
              policy_effective_date: updatedValue,
            };
          } else if (insurance.insurance_id === id && Check === "end_date") {
            return {
              ...schema,
              policy_end_date: updatedValue,
            };
          }
          return schema;
        }),
      };
    });
    setAllRows(updatedRows);
    console.log("Updated allRows:", updatedRows);
  };

  const handleSubmitRow = (e, rowId) => {
    console.log("elllllllllllllllllll........eeeeeeee", e.rowId);

    e.preventDefault();
    const idExists = allRowsInitial.some((obj) => obj.insurance_id == rowId);
    if (!idExists) {
      //For new row
      const currentRow = allRows.find((row) => row.insurance_id == rowId);
      const currentRowSchemas = currentRow.schemas.map((schema) => ({
        type: "edit",
        scheme_name: schema.scheme_name,
        employee: schema.employee,
        spouse: schema.spouse,
        child: schema.child,
        policy_no: schema.policy_no,
        policy_effective_date: schema.policy_effective_date,
        policy_end_date: schema.policy_end_date,
      }));
      const data = {
        type: "new",
        name: currentRow.name,
        insurance_scheme: currentRowSchemas,
      };
      console.log("data to be printed here.....", data);

      axios
        .post("/dashboard/insurance", data, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          console.log(res.data, "resId");
          // const data = {
          //   insurance_id: res.data.data.insurance.id,
          //   name: res.data.data.insurance.name,
          //   schemas: res.data.data.insurance_scheme,
          //   editing: false,
          // };
          // allRowsInitial.push(data);
          // setAllRows([...allRowsInitial]);
          setUpdateData((prev) => !prev);
          dispatch(
            setAppError({
              msg: res?.data?.message,
              color: "success",
            })
          );
        })
        .catch((error) => {
          console.log(error);
          dispatch(
            setAppError({
              msg: error?.response?.data?.message || error?.message,
            })
          );
        });
    } else {
      // For exisiting row
      const currentRow = allRows.find((row) => row.insurance_id == rowId);
      const currentRowSchemas = currentRow.schemas.map((schema) => ({
        type: "edit",
        scheme_id: schema.id,
        scheme_name: schema.scheme_name,
        employee: schema.employee,
        spouse: schema.spouse,
        child: schema.child,
        policy_no: schema.policy_no,
        policy_effective_date: schema.policy_effective_date,
        policy_end_date: schema.policy_end_date,
      }));
      axios
        .put(
          `/dashboard/insurance/${rowId}`,
          {
            insurance_name: currentRow.name,
            insurance_scheme: currentRowSchemas,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((response) => {
          console.log(response);
          dispatch(
            setAppError({
              msg: response?.data?.message,
              color: "success",
            })
          );
          setUpdateData((prev) => !prev);
        })
        .catch((error) => {
          console.log(error);
          dispatch(
            setAppError({
              msg: error?.response?.data?.message || error?.message,
            })
          );
        });
    }
  };

  const handleDeleteSchema = (rowId, schemaId) => {
    axios
      .put(
        `/dashboard/insurance/${rowId}`,
        {
          insurance_name: "demo",
          insurance_scheme: [
            {
              type: "delete",
              scheme_id: schemaId,
            },
          ],
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        console.log(response);
        setUpdateData((prev) => !prev);
        dispatch(
          setAppError({
            msg: response?.data?.message,
            color: "success",
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          setAppError({
            msg: error?.response?.data?.message || error?.message,
          })
        );
      });
  };

  const handleDeleteRow = (rowId) => {
    const currentRow = allRowsInitial.find((row) => row.insurance_id == rowId);
    if (currentRow) {
      axios
        .delete(`/dashboard/insurance/${rowId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          console.log(response);
          dispatch(
            setAppError({
              msg: response?.data?.message,
              color: "success",
            })
          );
          setUpdateData((prev) => !prev);
        })
        .catch((error) => {
          console.log(error);
          dispatch(
            setAppError({
              msg: error?.response?.data?.message || error?.message,
            })
          );
        });
    } else {
      setAllRows((prevState) =>
        prevState.filter((row) => row.insurance_id != rowId)
      );
    }
  };

  useEffect(() => {
    dispatch(
      setBreadCrumb([{ label: "INSURANCE COMPANY", link: "insurance-company" }])
    );
  }, [location.pathname]);

  console.log("Insurance Data to be seen here......", allRows);

  return (
    <>
      {/* {showDeletePrompt.open && (
        <DeletePrompt
          showPromptElement={showDeletePrompt}
          setShowPromptElement={setShowDeletePrompt}
          deleteHandler={showDeletePrompt.deleteHandler}
        />
      )} */}
      {/* {isExistingPopupOpen.open && (
        <RowExistingPopup
          showPromptElement={isExistingPopupOpen}
          setShowPromptElement={setIsExistingPopupOpen}
        />
      )} */}
      <div className="w-full !uppercase p-5 " ref={insuranceComponentDiv}>
        {/* Search and button */}
        <div>
          <button
            className="p-2 px-4 rounded-md bg-red text-white uppercase"
            onClick={handleCreateRow}
          >
            Add New Insurance Company +{" "}
          </button>
        </div>

        {/* Table view */}
        <div className="min-w-full p-5 flex flex-col gap-[0.15rem] ">
          <div className="flex items-center font-medium gap-1">
            <p className="p-2 bg-slate-200 min-w-[15rem] h-10">
              INSURANCE COMPANY
            </p>
            <p className="p-2 bg-slate-200 min-w-[12rem] h-10">Policy number</p>
            <p className="p-2 bg-slate-200 min-w-[12rem] h-10">
              Policy start date
            </p>
            <p className="p-2 bg-slate-200 min-w-[12rem] h-10">
              Policy end date
            </p>
            {allTitles.map((title) => (
              <div key={title.id} className="bg-slate-200 flex gap-1">
                <p className="bg-orange-200 p-2 w-36 h-10">{title.mainTitle}</p>
                <p className="p-2 w-36 h-10">{title.employee}</p>
                <p className="p-2 w-36 h-10">{title.spouse}</p>
                <p className="p-2 w-36 h-10">{title.child}</p>
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-[0.15rem] ">
            {allRows?.map((row, i) => (
              <form
                key={row.insurance_id}
                className="flex items-center text-sm relative gap-1"
                onSubmit={(e) => handleSubmitRow(e, row.insurance_id)}
              >
                <button
                  type="button"
                  className="absolute transform -translate-y-1/2 top-1/2 -left-7 p-[0.2rem] bg-red text-white rounded-md ml-[0.15rem] shadow-xl cursor-pointer"
                  onClick={() =>
                    setShowDeletePrompt({
                      open: true,
                      rowId: row.insurance_id,
                      deleteHandler: handleDeleteRow,
                    })
                  }
                  title="Delete Insurance"
                >
                  <MdDelete size={"1rem"} />
                </button>
                <input
                  type="text"
                  className="input input-xs focus:outline-none h-7  rounded-none bg-slate-200 min-w-[15rem] uppercase"
                  defaultValue={row.name}
                  disabled={!row.editing}
                  required
                  onChange={(e) =>
                    handleUpdateRowName(row.insurance_id, e.target.value)
                  }
                  placeholder="Enter Company name"
                />
                <input
                  type="number"
                  className="input input-xs focus:outline-none h-7  rounded-none bg-slate-200 min-w-[12rem] uppercase"
                  defaultValue={ 
                    parseInt(allRows[i].schemas[0]?.policy_no) 
                  }
                  disabled={!row.editing}
                  // required
                  onChange={(e) =>
                    handlepolicyrowUpdate(
                      row.insurance_id,
                      e.target.value,
                      "policy_no"
                    )
                  }
                  placeholder="Enter Company name"
                />
                <input
                  type="date"
                  className="input input-xs focus:outline-none h-7  rounded-none bg-slate-200 min-w-[12rem] uppercase"
                  // defaultValue={row.schemas[i].policy_effective_date}
                  defaultValue={
                    allRows[i].schemas[0]?.policy_effective_date?.split(" ")[0]
                  }
                  disabled={!row.editing}
                  // required
                  onChange={(e) =>
                    handlepolicyrowUpdate(
                      row.insurance_id,
                      e.target.value,
                      "effective_date"
                    )
                  }
                  placeholder="Enter Company name"
                />
                <input
                  type="date"
                  className="input input-xs focus:outline-none h-7  rounded-none bg-slate-200 min-w-[12rem] uppercase"
                  // defaultValue={row.policy_end_date}
                  defaultValue={allRows[i].schemas[0]?.policy_end_date?.split(" ")[0]}
                  disabled={!row.editing}
                  // required
                  onChange={(e) =>
                    handlepolicyrowUpdate(
                      row.insurance_id,
                      e.target.value,
                      "end_date"
                    )
                  }
                  placeholder="Enter Company name"
                />

                {row?.schemas?.map((schema, schemaIndex) => (
                  <div key={schema.id} className="flex gap-1 relative">
                    {schemaIndex != 0 &&
                      schemaIndex != 1 &&
                      schemaIndex != 2 &&
                      schemaIndex != 3 && (
                        <button
                          type="button"
                          className="absolute transform -translate-y-1/2 top-1/2 p-[0.2rem] bg-red text-white rounded-md ml-[0.15rem] shadow-xl"
                          onClick={() =>
                            setShowDeletePrompt({
                              open: true,
                              rowId: row.insurance_id,
                              schemaId: schema.id,
                              deleteHandler: handleDeleteSchema,
                            })
                          }
                          title="Delete Scheme"
                        >
                          <MdDelete size={"1rem"} />
                        </button>
                      )}

                    <input
                      type="text"
                      className="input input-xs focus:outline-none h-7 w-36 rounded-none !bg-orange-200 pl-7 uppercase"
                      defaultValue={schema.scheme_name}
                      disabled={!row.editing}
                      required
                      onChange={(e) =>
                        handleUpdateColumn(
                          row.insurance_id,
                          schema.id,
                          "scheme_name",
                          e.target.value.toUpperCase()
                        )
                      }
                      placeholder="Enter Scheme"
                    />
                    <input
                      type="text"
                      className="input input-xs focus:outline-none h-7 w-36 rounded-none bg-slate-200 uppercase"
                      defaultValue={schema.employee}
                      disabled={!row.editing}
                      required
                      onChange={(e) =>
                        handleUpdateColumn(
                          row.insurance_id,
                          schema.id,
                          "employee",
                          e.target.value.toUpperCase()
                        )
                      }
                      placeholder="Enter Employee"
                    />
                    <input
                      type="text"
                      className="input input-xs focus:outline-none h-7 w-36 rounded-none bg-slate-200 uppercase"
                      defaultValue={schema.spouse}
                      disabled={!row.editing}
                      required
                      onChange={(e) =>
                        handleUpdateColumn(
                          row.insurance_id,
                          schema.id,
                          "spouse",
                          e.target.value.toUpperCase()
                        )
                      }
                      placeholder="Enter Spouse"
                    />
                    <input
                      type="text"
                      className="input input-xs focus:outline-none h-7 w-36 rounded-none bg-slate-200 uppercase"
                      defaultValue={schema.child}
                      disabled={!row.editing}
                      required
                      onChange={(e) =>
                        handleUpdateColumn(
                          row.insurance_id,
                          schema.id,
                          "child",
                          e.target.value.toUpperCase()
                        )
                      }
                      placeholder="Enter Child"
                    />
                  </div>
                ))}
                {row.editing ? (
                  <button
                    type="submit"
                    className="ring-1 ring-slate-300 rounded-md p-1 "
                  >
                    <BsCheck size={"1.2rem"} />
                  </button>
                ) : (
                  <p
                    className="ring-1 ring-slate-300 rounded-md p-1 cursor-pointer"
                    onClick={(e) => handleEnableRowEdit(row.insurance_id)}
                  >
                    <CiEdit size={"1.2rem"} />
                  </p>
                )}
                <button
                  type="button"
                  className="ring-1 ring-slate-300 rounded-md p-1 disabled:cursor-not-allowed"
                  onClick={() =>
                    setIsExistingPopupOpen({
                      open: true,
                      rowId: row.insurance_id,
                      submitted: false,
                    })
                  }
                  disabled={row.editing}
                >
                  <BiPlus size={"1.2rem"} />
                </button>
              </form>
            ))}
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
}
